export const themeNames = ['topic', 'analysis', 'datalab', 'vantage', 'insights'] as const;
export const I18N_NAMESPACE = 'qomponents';

export type QomponentsTheme = (typeof themeNames)[number];
